module.exports = __webpack_public_path__ + "static/img/img5.307f25d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trade/img5.png
// module id = KoZd
// module chunks = 1